import { useRef } from 'react';
import { useScrollProgress } from '../hooks';
import { useContent } from '../siteContent';

// Scattered start offsets (in em) for each piece of daily work before it settles into Mealnex.
const scatter: { x: number; y: number; r: number }[] = [
  { x: -9, y: -11, r: -8 }, { x: 7, y: -13, r: 6 }, { x: 14, y: -4, r: -5 }, { x: -15, y: 1, r: 7 }, { x: 2, y: -6, r: -3 },
  { x: 16, y: 6, r: 9 }, { x: -13, y: 12, r: -6 }, { x: 5, y: 14, r: 5 }, { x: -4, y: 9, r: -9 },
];

export function System() {
  const { system } = useContent();
  const ref = useRef<HTMLDivElement>(null);
  useScrollProgress(ref, { mode: 'sticky' });
  if (!system.visible) return null;
  return <section id="system" className="mx-system" aria-labelledby="system-title">
    <div ref={ref} className="mx-converge">
      <div className="mx-converge-sticky mx-container">
        <div className="mx-converge-copy">
          <h2 id="system-title" className="mx-h2"><span className="mx-muted-line">{system.line1}</span><span>{system.line2}</span></h2>
          <p className="mx-body">{system.body}</p>
          {system.final && <p className="mx-converge-final">{system.final}</p>}
        </div>
        <div className="mx-converge-stage" aria-hidden="true">
          <div className="mx-converge-frame">
            <div className="mx-converge-bar"><i /><i /><i /><span>ميلنكس</span></div>
            <div className="mx-converge-grid">
              {system.pieces.slice(0, 12).map((label, index) => { const piece = scatter[index % scatter.length]; return <span key={`${label}-${index}`} className="mx-piece" style={{ '--sx': piece.x, '--sy': piece.y, '--sr': piece.r } as React.CSSProperties}>{label}</span>; })}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="mx-container">
      {system.statement && <p className="mx-statement">{system.statement}</p>}
      <ul className="mx-advantages">
        {system.advantages.map(item => <li key={item.title}><h3>{item.title}</h3><p>{item.text}</p></li>)}
      </ul>
    </div>
  </section>;
}
